import React from 'react';
import { TextLog } from 'modules/emergencies/components/ui/texts/LogText';
import { LogTitleContainer } from '../../ui/containers/logTitleContainer';
import LogIcon from 'modules/emergencies/components/log/LogIcon';

const NotificationFailedLogTitle = ({ titleData = {}, title, icon }) => {
  const { hasSubtitle, log } = titleData;
  const shipper = log.target?.data?.shipper_data?.company_name;

  return (
    <LogTitleContainer>
      <LogIcon icon={icon} />
      <TextLog color="#263340">{title}</TextLog>
      {hasSubtitle && <TextLog color="#54708C">/ {shipper || '-'}</TextLog>}
    </LogTitleContainer>
  );
};

export default NotificationFailedLogTitle;
